import { Type } from "@sinclair/typebox";
import { DateTimeSchema, EmailInputSchema, EmailSchema, UnitSystemSchema, UserIdSchema, } from "./auth.js";
export const RoleSchema = Type.Union([
    Type.Literal("admin"),
    Type.Literal("planner"),
    Type.Literal("supervisor"),
    Type.Literal("executor"),
    Type.Literal("viewer"),
]);
export const MembershipStatusSchema = Type.Union([
    Type.Literal("active"),
    Type.Literal("password_change_required"),
    Type.Literal("removed"),
]);
export const OrgSummarySchema = Type.Object({
    id: UserIdSchema,
    name: Type.String({ minLength: 1 }),
    country: Type.String({ minLength: 1 }),
    unitSystem: UnitSystemSchema,
    role: RoleSchema,
}, { additionalProperties: false });
export const MemberSchema = Type.Object({
    id: UserIdSchema,
    userId: UserIdSchema,
    name: Type.String({ minLength: 1 }),
    email: EmailSchema,
    role: RoleSchema,
    status: MembershipStatusSchema,
    lastActiveAt: Type.Union([DateTimeSchema, Type.Null()]),
    createdAt: DateTimeSchema,
}, { additionalProperties: false });
export const OrgDetailSchema = Type.Object({
    id: UserIdSchema,
    name: Type.String({ minLength: 1 }),
    country: Type.String({ minLength: 1 }),
    unitSystem: UnitSystemSchema,
    role: RoleSchema,
    activeMemberCount: Type.Integer({ minimum: 0 }),
    members: Type.Array(MemberSchema),
}, { additionalProperties: false });
export const OrgListResponseSchema = Type.Object({ orgs: Type.Array(OrgSummarySchema) }, { additionalProperties: false });
export const CreateMemberRequestSchema = Type.Object({
    name: Type.String({ minLength: 1, maxLength: 120 }),
    email: EmailInputSchema,
    role: RoleSchema,
}, { additionalProperties: false });
export const CreateMemberResponseSchema = Type.Object({
    member: MemberSchema,
}, { additionalProperties: false });
export const UpdateMemberRequestSchema = Type.Object({ role: RoleSchema }, { additionalProperties: false });
export const MemberResponseSchema = Type.Object({ member: MemberSchema }, { additionalProperties: false });
export const MeResponseSchema = Type.Object({
    user: Type.Object({
        id: UserIdSchema,
        email: EmailSchema,
        name: Type.String({ minLength: 1 }),
        mustChangePassword: Type.Boolean(),
        unitSystemOverride: Type.Union([UnitSystemSchema, Type.Null()]),
    }, { additionalProperties: false }),
    orgs: Type.Array(OrgSummarySchema),
}, { additionalProperties: false });
//# sourceMappingURL=org.js.map